import React from 'react';
import fr from 'facet-rest';
import { pickComponentAndProps } from 'Helpers/Affordances';
import useUserContext from 'Context/UserContext';
import NullComponent from 'Components/UI/NullComponent';
import Container from './Container';

const MyClientsPicker = () => {
  const { userResource } = useUserContext();
  const { component: MyClientsComponent, props: componentProps } = pickComponentAndProps(userResource, {
    [fr.relationships.householdSummary.name]: [Container, {}],
    [fr.relationships.default.name]: [NullComponent, {}],
  });

  return (
    <MyClientsComponent {...componentProps} />
  );
};

export default MyClientsPicker;
